import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 20px;

  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const TitleContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Nickname = styled.span`
  color: ${({ theme }) => theme['font-secondary']};
`;

export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;

  ul {
    margin-left: 20px;
    width: calc(100% - 40px);
    li {
      list-style-type: circle;
    }
  }
`;

export const ReasonHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ReasonContainer = styled.form`
  width: 100%;

  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;

  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme['gray-tertiary']};
`;

export const ReasonItem = styled.div`
  width: 100%;
  padding: 0px 20px;

  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 14px;

  label {
    flex-shrink: 0;
  }

  input[type='checkbox'] {
    flex-shrink: 0;
    appearance: none; /* 원래 제공되는 체크박스 없애기 */
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme['gray-tertiary']};

    &:checked {
      border: none;
      background: center no-repeat url('/icons/check.svg');
      background-size: contain;
    }
  }

  input[type='text'] {
    width: 100%;
    appearance: none;
    border: none;

    padding: 4px 0px;

    font-family: 'Pretendard';
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    color: ${({ theme }) => theme['font-secondary']};
  }

  input[type='text']::placeholder {
    color: ${({ theme }) => theme['font-tertiary']};

    font-family: 'Pretendard';
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
  }
`;

export const WarnText = styled.span`
  color: ${({ theme }) => theme['red-primary']};
`;

export const BottomButtonsContainer = styled.div`
  width: 100%;
  padding: 15px 24px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  background-color: white;
`;
